import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { ArchiveContext } from '../../archive-context';
import { messages } from '../../messages';
import style from '../../style.module.less';

const ArchiveNumberOfOrdersColumn = ({ archiveId }) => {
  const { archives } = useContext(ArchiveContext);
  return <div className={style['item-cell']}>{archives[archiveId]?.orderCount}</div>;
};

ArchiveNumberOfOrdersColumn.propTypes = {
  archiveId: PropTypes.string.isRequired,
};

export default {
  getMessageDescriptor: () => <FormattedMessage {...messages.archiveNumberOfOrders} />,
  id: 'archiveNumberOfOrders',
  render: ArchiveNumberOfOrdersColumn,
};
